import { useState } from "react";
import BotaoDuvidaTecnica from "./BotoesAssistenciaTecnica/BotaoDuvidaTecnica";
import BotaoExecucaoManuntecaoConcluida from "./BotoesAssistenciaTecnica/BotaoManuntecaoConcluida";
import ModalComponent from "../../../../Components/Modais";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import BotaoNaoProcedenteAvaliarProcedencia from "./BotoesAssistenciaTecnica/BotaoManuntencaoNaoProcedente";
import BotaoAvancarEtapa from "./BotoesAssistenciaTecnica/BotaoAvancarEtapa";
import BotaoFinalizarSolicitacao from "./BotoesAssistenciaTecnica/BotaoFinalizarSolicitacao";
import BotoesVistoriaNaoRealizada from "./BotoesAssistenciaTecnica/BotoesVistoriaNaoRealizada";
import BotoesManutencaoNaoRealizada from "./BotoesAssistenciaTecnica/BotoesManuntecaoNaoRealizada";
import BotaoResponderDuvidaTecnica from "./BotoesAssistenciaTecnica/BotaoResponderDuvidaTecnica";
import BotaoValidarSolicitacaoNaoProcedente from "./BotoesAssistenciaTecnica/BotaoValidarSolicitacaoNaoProcedente";
import BotaoParalisarEReiniciarManutencao from "./BotoesAssistenciaTecnica/BotaoParalisarManutencao";
import BotaoVistoriaRealizadaManutencaoProcedente from "./BotoesAssistenciaTecnica/BotaoVistoriaRealizadaManutencaoProcedente";
import BotaoFinalizarReparo from "../../../../Components/CardsPages/BotoesAssistenciaTecnica/BotaoFinalizarManutencao";
import BotaoResponderPesquisaDeSatisfacao from "./BotoesAssistenciaTecnica/BotaoResponderPesquisaDeSatisfacao";
import BotaoVerPesquisaDeSatisfacao from "./BotoesAssistenciaTecnica/BotaoVerPesquisaDeSatisfacao";
import BotaoReenviarPesquisaSatisfacao from "./BotoesAssistenciaTecnica/BotaoReenviarPesquisa";
import BotaoAvancarSemResponderPesquisa from "./BotoesAssistenciaTecnica/BotaoAvancarSemResponderPesquisa";
import { ETAPA_ASSISTENCIA_TECNICA } from "../../../../Constants/AssistenciaTecnica/EtapaTipoCaso";
import { IAtendimentoExtraDetalhado } from "../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { useUserInfor } from "../../../../Context/User";
import BotaoAgendamentoReparoClienteAusente from "./BotoesAssistenciaTecnica/BotaoAgendamentoReparoClienteAusente";
import { ListAcoesAcessoUsuarioController } from "../../../../Controllers/Geral/AcaoEtapa/AcaoEtapaControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";

interface IAcoesAssistenciaTecnicaProps {
    emccampMode: string;
}

export default function AcoesAssitenciaTecnica(
    props: IAcoesAssistenciaTecnicaProps
) {
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;

    const Atendimento = useAtendimentoPage()
        .Atendimento as IAtendimentoExtraDetalhado;
    const { ConfigAssistenciaTecnicaDTO } = useUserInfor().Config;
    const { value: AcaoAcessoUsuario } = useAsyncEffect(async () => {
        return ListAcoesAcessoUsuarioController(Atendimento.NR_ETAPA);
    }, [Atendimento]);

    return (
        <div className="card card-custom px-8 py-4 mb-5">
            <h4 className="text-center mb-0">Ações de Etapa</h4>
            <hr />
            {Atendimento?.FL_CASO_PARALIZADO ? (
                <span className="text-center text-danger">
                    O caso encontra-se paralisado, portanto as ações de etapa
                    estão indisponíveis.
                </span>
            ) : (
                <>
                    {Atendimento.FL_SINCRONIZADO && (
                        <span className="text-center text-danger font-weight-bolder my-3">
                            O Aplicativo deve estar sincronizado para realizar
                            esta ação.
                        </span>
                    )}
                    <div className="g-5  d-flex flex-row flex-wrap justify-content-center">
                        {[
                            ETAPA_ASSISTENCIA_TECNICA.AVALIACAO_DE_PROCEDENCIA
                                .CD_ETAPA,
                            ETAPA_ASSISTENCIA_TECNICA
                                .AGENDAMENTO_VISTORIA_INICIAL.CD_ETAPA,
                            ETAPA_ASSISTENCIA_TECNICA.AGENDAR_MANUTENCAO
                                .CD_ETAPA,
                        ].some(
                            (etapa) => etapa === Number(Atendimento?.CD_ETAPA)
                        ) && (
                            <BotaoAvancarEtapa
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        )}
                        {props.emccampMode === ID_ORGANIZACAO &&
                            Number(Atendimento.CD_ETAPA) ===
                                ETAPA_ASSISTENCIA_TECNICA
                                    .FECHAMENTO_DE_MANUTENCAO.CD_ETAPA && (
                                <BotaoAvancarEtapa
                                    AcaoAcessoUsuario={AcaoAcessoUsuario}
                                />
                            )}
                        {ConfigAssistenciaTecnicaDTO?.FL_PERMITIR_MANUTENCAO_CONCLUIDA &&
                            Number(Atendimento?.CD_ETAPA) ===
                                ETAPA_ASSISTENCIA_TECNICA.EXECUCAO_DE_MANUTENCAO
                                    .CD_ETAPA && (
                                <BotaoExecucaoManuntecaoConcluida
                                    setShow={setShow}
                                    setModal={setModal}
                                    AcaoAcessoUsuario={AcaoAcessoUsuario}
                                />
                            )}
                        {Number(Atendimento?.CD_ETAPA) ===
                            ETAPA_ASSISTENCIA_TECNICA
                                .VALIDACAO_ATENDIMENTO_NAO_PROCEDENTE
                                .CD_ETAPA &&
                        props.emccampMode !== ID_ORGANIZACAO ? (
                            <BotaoValidarSolicitacaoNaoProcedente
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        ) : null}
                        {Number(Atendimento?.CD_ETAPA) ===
                            ETAPA_ASSISTENCIA_TECNICA
                                .VALIDACAO_ATENDIMENTO_NAO_PROCEDENTE
                                .CD_ETAPA &&
                        props.emccampMode !== ID_ORGANIZACAO ? (
                            <BotaoFinalizarSolicitacao
                                setShow={setShow}
                                setModal={setModal}
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        ) : null}
                        {[
                            ETAPA_ASSISTENCIA_TECNICA.AVALIACAO_DE_PROCEDENCIA
                                .CD_ETAPA,
                            ETAPA_ASSISTENCIA_TECNICA
                                .AGENDAMENTO_VISTORIA_INICIAL.CD_ETAPA,
                            ETAPA_ASSISTENCIA_TECNICA.EXECUCAO_VISTORIA_INICIAL
                                .CD_ETAPA,
                            ETAPA_ASSISTENCIA_TECNICA.VALIDACAO_ATENDIMENTO_NAO_PROCEDENTE,
                        ].some(
                            (etapa) => etapa === Number(Atendimento?.CD_ETAPA)
                        ) && (
                            <BotaoFinalizarSolicitacao
                                setShow={setShow}
                                setModal={setModal}
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        )}
                        {[
                            ETAPA_ASSISTENCIA_TECNICA.AVALIACAO_DE_PROCEDENCIA
                                .CD_ETAPA,
                            ETAPA_ASSISTENCIA_TECNICA.EXECUCAO_VISTORIA_INICIAL
                                .CD_ETAPA,
                        ].some(
                            (etapa) => etapa === Number(Atendimento?.CD_ETAPA)
                        ) &&
                            ID_ORGANIZACAO !== props.emccampMode && (
                                <BotaoNaoProcedenteAvaliarProcedencia
                                    setShow={setShow}
                                    setModal={setModal}
                                    AcaoAcessoUsuario={AcaoAcessoUsuario}
                                />
                            )}
                        {Number(Atendimento?.CD_ETAPA) ===
                            ETAPA_ASSISTENCIA_TECNICA.EXECUCAO_VISTORIA_INICIAL
                                .CD_ETAPA && (
                            <BotaoVistoriaRealizadaManutencaoProcedente
                                setShow={setShow}
                                setModal={setModal}
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        )}
                        {Number(Atendimento?.CD_ETAPA) ===
                            ETAPA_ASSISTENCIA_TECNICA.EXECUCAO_VISTORIA_INICIAL
                                .CD_ETAPA && (
                            <BotoesVistoriaNaoRealizada
                                emccampMode={props.emccampMode}
                                ID_ORGANIZACAO={ID_ORGANIZACAO}
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        )}
                        {Number(Atendimento?.CD_ETAPA) ===
                            ETAPA_ASSISTENCIA_TECNICA.EXECUCAO_DE_MANUTENCAO
                                .CD_ETAPA && (
                            <BotoesManutencaoNaoRealizada
                                emccampMode={props.emccampMode}
                                ID_ORGANIZACAO={ID_ORGANIZACAO}
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        )}
                        {[
                            ETAPA_ASSISTENCIA_TECNICA.EXECUCAO_VISTORIA_INICIAL
                                .CD_ETAPA,
                        ].some(
                            (etapa) => etapa === Number(Atendimento?.CD_ETAPA)
                        ) && (
                            <BotaoDuvidaTecnica
                                setModal={setModal}
                                setShow={setShow}
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        )}
                        {props.emccampMode === ID_ORGANIZACAO &&
                            Number(Atendimento?.CD_ETAPA) ===
                                ETAPA_ASSISTENCIA_TECNICA
                                    .EXECUCAO_VISTORIA_INICIAL.CD_ETAPA && (
                                <BotaoAgendamentoReparoClienteAusente />
                            )}
                        {Number(Atendimento?.CD_ETAPA) ===
                            ETAPA_ASSISTENCIA_TECNICA.DUVIDA_TECNICA
                                .CD_ETAPA && (
                            <BotaoResponderDuvidaTecnica
                                setShow={setShow}
                                setModal={setModal}
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        )}
                        {Number(Atendimento?.CD_ETAPA) ===
                            ETAPA_ASSISTENCIA_TECNICA.AGENDAR_MANUTENCAO
                                .CD_ETAPA && (
                            <BotaoParalisarEReiniciarManutencao
                                setModal={setModal}
                                setShow={setShow}
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        )}
                        {(Number(Atendimento?.CD_ETAPA) ===
                            ETAPA_ASSISTENCIA_TECNICA
                                .VALIDACAO_ATENDIMENTO_NAO_PROCEDENTE
                                .CD_ETAPA &&
                            props.emccampMode === ID_ORGANIZACAO) ||
                        (Number(Atendimento?.CD_ETAPA) ===
                            ETAPA_ASSISTENCIA_TECNICA.FECHAMENTO_DE_MANUTENCAO
                                .CD_ETAPA &&
                            props.emccampMode !== ID_ORGANIZACAO) ? (
                            <BotaoFinalizarReparo
                                setModal={setModal}
                                setShow={setShow}
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        ) : null}
                        {Number(Atendimento?.CD_ETAPA) ===
                            ETAPA_ASSISTENCIA_TECNICA.PESQUISA_SATISFACAO
                                .CD_ETAPA && (
                            <BotaoReenviarPesquisaSatisfacao
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        )}
                        {Number(Atendimento?.CD_ETAPA) ===
                            ETAPA_ASSISTENCIA_TECNICA.PESQUISA_SATISFACAO
                                .CD_ETAPA && (
                            <BotaoResponderPesquisaDeSatisfacao
                                tpPesquisa="AssistenciaTec"
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                                setShow={setShow}
                                setModal={setModal}
                            />
                        )}
                        {Number(Atendimento?.CD_ETAPA) ===
                            ETAPA_ASSISTENCIA_TECNICA.PESQUISA_SATISFACAO
                                .CD_ETAPA && (
                            <BotaoAvancarSemResponderPesquisa
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        )}
                        {Number(Atendimento?.CD_ETAPA) ===
                            ETAPA_ASSISTENCIA_TECNICA.FECHAMENTO_DE_MANUTENCAO
                                .CD_ETAPA && (
                            <BotaoVerPesquisaDeSatisfacao
                                setShow={setShow}
                                setModal={setModal}
                                AcaoAcessoUsuario={AcaoAcessoUsuario}
                            />
                        )}
                        <ModalComponent
                            show={show}
                            setShow={setShow}
                            ModalComponent={modal}
                        />
                    </div>
                </>
            )}
        </div>
    );
}
